import { Component } from '@angular/core';
// noinspection ES6PreferShortImport
import { EnumTransformService } from '../../services/enum-transform.service';

@Component({
  selector: 'pt-enum-to-adverbs-renderer',
  template: `<span>{{params.valueFormatted | async}}</span>`
})
export class EnumToAdverbsFilterCellRendererComponent {

  params: any;

  constructor(private enumTransformService: EnumTransformService) {
  }

  agInit(params: any): void {
    this.params = params;
    this.params.valueFormatted = this.enumTransformService.toAdverb(this.params.value);
  }

}
